import { createFeatureSelector, createSelector } from "@ngrx/store";
import { HOME_PAGE_FEATURE, homePageState } from "../homepage.state";

export const getHomePage = createFeatureSelector<homePageState>(HOME_PAGE_FEATURE);

export const selectCarouselImages = createSelector(
    getHomePage,
    (state: homePageState) => state?.fetchCarouselImages?.imageList
);

export const updatedImageIndexSelector = createSelector(
    getHomePage,
    (state: homePageState) => state?.fetchCarouselImages?.activeIndex
);

export const categoriesSelector = createSelector(
    getHomePage,
    (state: homePageState) => state?.fetchCategories?.categories
);

export const selectTopFeaturedProducts = createSelector(
    getHomePage,
    (state: homePageState) => state?.fetchTopFeatureProducts?.products
);